import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';

import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';

// services
import { ErrorHandler } from './error-handler.service';
// path globals
import { API_PATH, SUBSCRIPTION_KEY, EXCESS_BAGGAGE_PAYMENT } from '../../shared/globals';
import { AppState } from '../../booking/models/app-state.interface';

@Injectable({
  providedIn: 'root',
})
export class ExcessPaymentService {
  public excessPaymentSubject$: Subject<any> = new Subject();

  constructor (
    private _http: HttpClient,
    private _errorService: ErrorHandler,
    private _appStore: Store<AppState>
  ) {}

  createAuthorizationHeader(headers: HttpHeaders, token) {
    headers = headers.set('Authorization', 'bearer ' + token);
    return headers;  }

  postExcessPayment(request) {

    // const headers = new HttpHeaders();
    // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    let headers = new HttpHeaders();
    headers = headers.set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);

    headers = this.createAuthorizationHeader(headers, this.getState(this._appStore).userReducer.userDetails.userToken);
    this._http.post(API_PATH + EXCESS_BAGGAGE_PAYMENT, request, {headers: headers})
      .subscribe(
        (res:any) => {
          this.excessPaymentSubject$.next(res);
        },
        err => {
          this.excessPaymentSubject$.next('error');
          this._errorService.handleError(err);
          return;
        });
  }

  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1)).subscribe(s => state = s);
    return state;
  }

};
